var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "metamask",
    transform: "translate(12919 4380)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16247",
    "data-name": "Rectangle 16247",
    width: 32,
    height: 32,
    transform: "translate(-12919 -4380)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_74263ff26820cd0d895968e3b55e8902",
    "data-name": "74263ff26820cd0d895968e3b55e8902",
    transform: "translate(-12918.402 -4377.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17174",
    "data-name": "Path 17174",
    d: "M60.75,169.385l3.888,1.032v-1.349l.317-.317h2.222v2.7H64.8l-2.936-1.27Z",
    transform: "translate(-51.696 -144.461)",
    fill: "#cdbdb2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17175",
    "data-name": "Path 17175",
    d: "M0,2.063,3.809,1.031V2.381l.317.317H6.348V0H3.968L1.032,1.27Z",
    transform: "translate(21.75 26.986) rotate(180)",
    fill: "#cdbdb2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17176",
    "data-name": "Path 17176",
    d: "M88.63,150.022l-.317,2.619.4-.317h4.126l.476.317-.317-2.619-.635-.4-3.174.079Z",
    transform: "translate(-75.371 -128.034)",
    fill: "#393939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17177",
    "data-name": "Path 17177",
    d: "M75.375,27l1.9,4.444.873,12.934h3.095L82.2,31.444,83.945,27Z",
    transform: "translate(-64.258 -22.708)",
    fill: "#f89c35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17178",
    "data-name": "Path 17178",
    d: "M2.785,81.694.563,88.121,6.118,87.8H9.688V85.026L9.53,79.313l-.794.635Z",
    transform: "translate(0 -67.641)",
    fill: "#f89d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17179",
    "data-name": "Path 17179",
    d: "M46.125,101.25l6.507.159-.714,3.333-3.095-.794Z",
    transform: "translate(-39.135 -86.484)",
    fill: "#d87c30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17180",
    "data-name": "Path 17180",
    d: "M46.125,101.813l2.7,2.539v2.539Z",
    transform: "translate(-39.135 -86.967)",
    fill: "#ea8d3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17181",
    "data-name": "Path 17181",
    d: "M65.25,120.375l3.174.794,1.032,3.412-.714.4-3.491-2.063Z",
    transform: "translate(-55.562 -102.911)",
    fill: "#f89d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17182",
    "data-name": "Path 17182",
    d: "M61.385,138.375l-.635,4.92,4.206-2.936Z",
    transform: "translate(-51.696 -118.371)",
    fill: "#eb8f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17183",
    "data-name": "Path 17183",
    d: "M87.419,102.375l.4,6.745-1.19-3.452Z",
    transform: "translate(-73.921 -87.45)",
    fill: "#ea8e3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17184",
    "data-name": "Path 17184",
    d: "M39.375,138.454l3.65-.079-.635,4.92Z",
    transform: "translate(-33.337 -118.371)",
    fill: "#d87c30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17185",
    "data-name": "Path 17185",
    d: "M2.309,145.921l6.745-2.143-3.015-4.84-5.475.4Z",
    transform: "translate(0 -118.855)",
    fill: "#eb8f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17186",
    "data-name": "Path 17186",
    d: "M52.156,58.5l-3.412,2.857-2.619,3.174,6.507.238Z",
    transform: "translate(-39.135 -49.764)",
    fill: "#e8821e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17187",
    "data-name": "Path 17187",
    d: "M60.75,155.374l4.206-2.936-.317,2.539v1.428l-2.857-.556Z",
    transform: "translate(-51.696 -130.451)",
    fill: "#dfcec3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17188",
    "data-name": "Path 17188",
    d: "M0,1.032,4.126,3.968,3.809,1.428V0L.952.556Z",
    transform: "translate(21.75 25.955) rotate(180)",
    fill: "#dfcec3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17189",
    "data-name": "Path 17189",
    d: "M.873,1.825,0,0,3.095.794Z",
    transform: "translate(12.624 18.179) rotate(180)",
    fill: "#393939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17190",
    "data-name": "Path 17190",
    d: "M12.375.563,23.167,8.736,21.342,4.292Z",
    transform: "translate(-10.146 0)",
    fill: "#e88f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17191",
    "data-name": "Path 17191",
    d: "M3.678.563,2.25,4.927l.794,4.761-.555.317.794.714-.635.555.873.794-.555.476,1.27,1.587,5.951-1.825A52.116,52.116,0,0,0,14.47,8.736Q14.391,8.656,3.678.563Z",
    transform: "translate(-1.449 0)",
    fill: "#8e5a30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59916",
    "data-name": "Group 59916",
    transform: "translate(30.24 27.066) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17192",
    "data-name": "Path 17192",
    d: "M2.222,6.427,0,0,5.555.317H9.125V3.095L8.967,8.808l-.794-.635Z",
    transform: "translate(0 6.586)",
    fill: "#f89d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17193",
    "data-name": "Path 17193",
    d: "M0,3.491l6.507-.159L5.793,0,2.7.794Z",
    transform: "translate(6.427 8.808)",
    fill: "#d87c30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17194",
    "data-name": "Path 17194",
    d: "M0,5.078,2.7,2.539V0Z",
    transform: "translate(6.427 7.142)",
    fill: "#ea8d3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17195",
    "data-name": "Path 17195",
    d: "M0,4.6l3.174-.794L4.206.4,3.491,0,0,2.063Z",
    transform: "translate(9.125 4.999)",
    fill: "#f89d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17196",
    "data-name": "Path 17196",
    d: "M.635,4.92,0,0,4.126,2.857Z",
    transform: "translate(8.491 2.143)",
    fill: "#eb8f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17197",
    "data-name": "Path 17197",
    d: "M.794,6.745,1.19,0,0,3.452Z",
    transform: "translate(12.141 5.396)",
    fill: "#ea8e3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17198",
    "data-name": "Path 17198",
    d: "M0,4.84l3.65.079L3.015,0Z",
    transform: "translate(5.475 2.143)",
    fill: "#d87c30",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17199",
    "data-name": "Path 17199",
    d: "M1.746,0,8.491,2.143,5.475,6.983,0,6.586Z",
    transform: "translate(0)",
    fill: "#eb8f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17200",
    "data-name": "Path 17200",
    d: "M6.031,6.269,2.619,3.412,0,.238,6.507,0Z",
    transform: "translate(6.427 12.061)",
    fill: "#e8821e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17201",
    "data-name": "Path 17201",
    d: "M.873,0,0,1.825l3.095-.794Z",
    transform: "translate(12.061 10.713) rotate(180)",
    fill: "#393939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17202",
    "data-name": "Path 17202",
    d: "M0,8.173,10.792,0,8.967,4.444Z",
    transform: "translate(1.666 18.33)",
    fill: "#e88f35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17203",
    "data-name": "Path 17203",
    d: "M1.428,13.569,0,9.2.794,4.444.238,4.126l.794-.714L.4,2.857l.873-.794L.714,1.587,1.984,0,7.935,1.825A52.117,52.117,0,0,1,12.22,5.4Q12.141,5.475,1.428,13.569Z",
    transform: "translate(0.238 12.934)",
    fill: "#8e5a30",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.808bfd481f0ca5ab1ea721c5e81017cc.svg";
export { ForwardRef as ReactComponent };